import { useContextoApp } from "@/app/contexto";
import { useApiResource } from "@/hooks/useApiResource";
import type { Adjunto, CuentaMia } from "@/lib/api";
import { TONO_SALDO, cuentaDelSaldo, estadoSaldo, formatSaldo } from "@/lib/cuentas";
import { formatFecha, formatMoneda } from "@/lib/format";

/**
 * Lógica de Mi cuenta (sin JSX): lo del fiduciante logueado, simple (Mati, 2026-10-19): si está a favor o debe y
 * cuánto, lo que aportó y sus aportes con el comprobante. Sólo lectura.
 */
export function useMiCuentaTab() {
  const { fid } = useContextoApp();
  const base = `/api/fideicomisos/${fid}`;
  const mia = useApiResource<CuentaMia>(`${base}/cuentas/mia`);
  const sinFicha = mia.error?.status === 404;
  const cuenta = mia.data;
  const estado = cuenta ? estadoSaldo(cuenta.saldo_usd) : null;

  return {
    cargando: !cuenta && mia.loading,
    sinFicha,
    errorCarga: !cuenta && mia.error && !sinFicha ? mia.error.message : null,
    reintentar: mia.recargar,
    saldo:
      cuenta && estado
        ? { valor: formatSaldo(cuenta.saldo_usd), estado: cuentaDelSaldo(cuenta), tono: TONO_SALDO[estado], aportado: formatMoneda(cuenta.aportado_usd, "USD") }
        : null,
    aportes: (cuenta?.aportes ?? []).map((a) => ({
      id: a.id,
      fecha: formatFecha(a.fecha),
      monto: formatMoneda(a.monto, a.moneda),
      nota: a.nota,
      adjuntos: a.adjuntos,
    })),
    rutaDescarga: (a: Adjunto) => `${base}/adjuntos/${a.id}/descarga`,
  };
}
